import { SelectOption } from '../components/PhoneNumberForm/models';
import { PhoneNumber } from '../models/ProfileModel';

const formatPhoneNumber = (
  phone: PhoneNumber,
  countries: SelectOption[],
): string => {
  try {
    const country = countries.find(
      (c) => c.value === phone.countryId.toString(),
    );

    const dialingCodeParts = country?.text.split('+');
    const dialingCode = dialingCodeParts[1];

    return `+${dialingCode} ${phone.number}`;
  } catch {
    return phone.number;
  }
};

export default formatPhoneNumber;
